import {createSelector, Selector} from 'reselect';
import {PropertyID} from 'module/Properties/enum/PropID';
import {PropertiesStateType} from 'module/Properties/reducer/PropertiesReducer';
import {log} from 'common/log';

export const PropLog = {unfetchedUse: false}

type TransformFunction<T> = ((value: string | null) => T)

export function selPropGenString(propID: PropertyID, defaultValue: string | null = null) {
	return (state: PropertiesStateType) => {
		const id = propID.toString()
		const val = state.Properties[id]
		if (state.Properties.hasOwnProperty(id)) {
			if (defaultValue && val == null) return defaultValue;
			return val
		}
		if (PropLog.unfetchedUse) log.warn('Property used, but not fetched: ' + id)
		return defaultValue
	}
}

export function selPropGen<T>(propID: PropertyID, transform: TransformFunction<T>): Selector<PropertiesStateType, T> {
	return createSelector(
		selPropGenString(propID),
		transform,
	)
}

const selDict: { [propID in string]: Selector<PropertiesStateType, any> } = {}

/**
 * use only when transform function does not change
 */
export function selPropGenMemo<T>(propID: PropertyID, transform: TransformFunction<T>): Selector<PropertiesStateType, T> {
	const propIDstr = propID.toString()
	let sel: Selector<PropertiesStateType, T> = selDict[propIDstr]
	if (!sel) {
		sel = selDict[propIDstr] = selPropGen(propID, transform)
	}
	return sel
}